import React from "react";

import Router from "./Routers/Router";

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
